import React, { useEffect, useState, CSSProperties, useRef } from 'react';
import '../App.css';
import './Widgets.css'
import axios from 'axios';
import { TextField, Button, Stack } from "@mui/material"
import { ClipLoader, HashLoader, RingLoader } from "react-spinners";
import NavBar from '../Widgets/NavBar';
import Footer from '../Widgets/Footer';

export default function GradeCalculator() {

    const [isResult, setIsResult] = useState(false)
    const [finalGrades, setFinalGrades] = useState({})

    useEffect(() => {
        document.title = "Widgets";
    }, []);

    return (
        <div className="page-wrapper">
            <header className="py-5">
                <div className="container">
                    <div className="row">
                        <NavBar selected="grade-calculator-page"></NavBar>
                    </div>
                </div>
            </header>

            <Grades></Grades>

            <Footer></Footer>
        </div>
    );

    function Grades() {

        const [grades, setGrades] = useState([
            // 1º Ano - 1º Semestre
            { name: "Álgebra", ects: 4.5, grade: 0, state: "1A1S" },
            { name: "Algoritmos e Programação", ects: 8, grade: 0, state: "1A1S" },
            { name: "Análise Matemática", ects: 5.5, grade: 0, state: "1A1S" },
            { name: "Sistemas Digitais", ects: 6, grade: 0, state: "1A1S" },
            { name: "Tecnologia dos Computadores", ects: 6, grade: 0, state: "1A1S" },

            // 1º Ano - 2º Semestre
            { name: "Arquiteturas de Computador", ects: 5.5, grade: 0, state: "1A2S" },
            { name: "Estruturas de Dados", ects: 8, grade: 0, state: "1A2S" },
            { name: "Matemática Aplicada", ects: 5, grade: 0, state: "1A2S" },
            { name: "Matemática Discreta", ects: 5, grade: 0, state: "1A2S" },
            { name: "Redes de Comunicação I", ects: 6.5, grade: 0, state: "1A2S" },

            // 2º Ano - 1º Semestre
            { name: "Análise de Sistemas", ects: 6.5, grade: 0, state: "2A1S" },
            { name: "Aplicações para a Internet I", ects: 6.5, grade: 0, state: "2A1S" },
            { name: "Programação Orientada aos Objetos", ects: 6.5, grade: 0, state: "2A1S" },
            { name: "Sistemas Operativos", ects: 5.5, grade: 0, state: "2A1S" },
            { name: "Usabilidade", ects: 5, grade: 0, state: "2A1S" },

            // 2º Ano - 2º Semestre
            { name: "Aplicações para a Internet II", ects: 5, grade: 0, state: "2A2S" },
            { name: "Bases de Dados I", ects: 6, grade: 0, state: "2A2S" },
            { name: "Engenharia de Software I", ects: 4.5, grade: 0, state: "2A2S" },
            { name: "Programação para Dispositivos Móveis", ects: 5, grade: 0, state: "2A2S" },
            { name: "Projeto Integrado", ects: 5, grade: 0, state: "2A2S" },
            { name: "Redes de Comunicação II", ects: 4.5, grade: 0, state: "2A2S" },

            // 3º Ano - 1º Semestre
            { name: "Bases de Dados II", ects: 6, grade: 0, state: "3A1S" },
            { name: "Complementos de Sistemas Operativos", ects: 5, grade: 0, state: "3A1S" },
            { name: "Redes de Comunicação III", ects: 4.5, grade: 0, state: "3A1S" },
            { name: "Segurança Informática", ects: 4.5, grade: 0, state: "3A1S" },
            { name: "Sistemas Distribuídos", ects: 5, grade: 0, state: "3A1S" },
            { name: "Sistemas Embebidos", ects: 5, grade: 0, state: "3A1S" },

            // 3º Ano - 2º Semestre
            { name: "Empreendedorismo e Gestão de Empresas", ects: 3, grade: 0, state: "3A2S" },
            { name: "Engenharia de Software II", ects: 6, grade: 0, state: "3A2S" },
            { name: "Inteligência Artificial", ects: 5, grade: 0, state: "3A2S" },
            { name: "Projeto", ects: 16, grade: 0, state: "3A2S" },
        ]);

        const handleGradeChange = (name, newGrade) => {
            setGrades((prevGrades) =>
                prevGrades.map((g) =>
                    g.name === name ? { ...g, grade: newGrade } : g
                )
            );
        };

        function calcularNotaFinal() {
            let final = {
                totalFinal: 0,
                total1A1S: 0,
                total1A2S: 0,
                total2A1S: 0,
                total2A2S: 0,
                total3A1S: 0,
                total3A2S: 0
            }
            grades.map((cadeira) => {
                console.log(cadeira)
                switch (cadeira.state) {
                    case "1A1S":
                        final.total1A1S += cadeira.grade * cadeira.ects;
                        break;
                    case "1A2S":
                        final.total1A2S += cadeira.grade * cadeira.ects;
                        break;
                    case "2A1S":
                        final.total2A1S += cadeira.grade * cadeira.ects;
                        break;
                    case "2A2S":
                        final.total2A2S += cadeira.grade * cadeira.ects;
                        break;
                    case "3A1S":
                        final.total3A1S += cadeira.grade * cadeira.ects;
                        break;
                    case "3A2S":
                        final.total3A2S += cadeira.grade * cadeira.ects;
                        break;
                }

                final.totalFinal += (cadeira.grade * cadeira.ects)
            })

            final.totalFinal /= 180;
            final.total1A1S /= 30;
            final.total1A2S /= 30;
            final.total2A1S /= 30;
            final.total2A2S /= 30;
            final.total3A1S /= 30;
            final.total3A2S /= 30;

            setIsResult(true)
            setFinalGrades(final)
        }


        return (
            <div className='container py-5'>
                <div className='row'>

                    {/* Primeiro Ano Primeiro Semestre */}
                    <div className='col-md-12 box border p-4 my-2' style={{ borderRadius: "20px" }}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <h4>1 Ano - 1 Semestre</h4>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Álgebra</h5>
                                <TextField
                                    type="text"
                                    name="Álgebra"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Álgebra", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Algoritmos e Programação</h5>
                                <TextField
                                    type="text"
                                    name="Algoritmos e Programação"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Algoritmos e Programação", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Análise Matemática</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Análise Matemática", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Sistemas Digitais</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Sistemas Digitais", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Tecnologia dos Computadores</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Tecnologia dos Computadores", parseInt(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Primeiro Ano Segundo Semestre */}
                    <div className='col-md-12 box border p-4 my-2' style={{ borderRadius: "20px" }}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <h4>1 Ano - 2 Semestre</h4>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Arquiteturas de Computador</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Arquiteturas de Computador", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Estruturas de Dados</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Estruturas de Dados", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Matemática Aplicada</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Matemática Aplicada", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Matemática Discreta</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Matemática Discreta", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Redes de Comunicação I</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Redes de Comunicação I", parseInt(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Segundo Ano Primeiro Semestre */}
                    <div className='col-md-12 box border p-4 my-2' style={{ borderRadius: "20px" }}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <h4>2 Ano - 1 Semestre</h4>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Análise de Sistemas</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Análise de Sistemas", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Aplicações para a Internet I</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Aplicações para a Internet I", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Programação Orientada aos Objetos</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Programação Orientada aos Objetos", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Sistemas Operativos</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Sistemas Operativos", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Usabilidade</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Usabilidade", parseInt(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Segundo Ano Segundo Semestre */}
                    <div className='col-md-12 box border p-4 my-2' style={{ borderRadius: "20px" }}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <h4>2 Ano - 2 Semestre</h4>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Aplicações para a Internet II</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Aplicações para a Internet II", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Bases de Dados I</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Bases de Dados I", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Engenharia de Software I</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Engenharia de Software I", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Programação para Dispositivos Móveis</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Programação para Dispositivos Móveis", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Projeto Integrado</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Projeto Integrado", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Redes de Comunicação II</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Redes de Comunicação II", parseInt(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Terceiro Ano Primeiro Semestre */}
                    <div className='col-md-12 box border p-4 my-2' style={{ borderRadius: "20px" }}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <h4>3 Ano - 1 Semestre</h4>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Bases de Dados II</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Bases de Dados II", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Complementos de Sistemas Operativos</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Complementos de Sistemas Operativos", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Redes de Comunicação III</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Redes de Comunicação III", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Segurança Informática</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Segurança Informática", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Sistemas Distribuídos</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Sistemas Distribuídos", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Sistemas Embebidos</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Sistemas Embebidos", parseInt(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Terceiro Ano Segundo Semestre */}
                    <div className='col-md-12 box border p-4 my-2' style={{ borderRadius: "20px" }}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <h4>3 Ano - 2 Semestre</h4>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Empreendedorismo e Gestão de Empresas</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Empreendedorismo e Gestão de Empresas", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Engenharia de Software II</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Engenharia de Software II", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Inteligência Artificial</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Inteligência Artificial", parseInt(e.target.value))}
                                />
                            </div>
                            <div className='col-md-6 d-flex align-items-center justify-content-between my-2'>
                                <h5>Projeto</h5>
                                <TextField
                                    type="text"
                                    name="city"
                                    InputProps={{
                                        sx: {
                                            color: "black",
                                            backgroundColor: "white",
                                            width: '50px'
                                        },
                                    }}
                                    onChange={(e) => handleGradeChange("Projeto", parseInt(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>

                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => console.log(calcularNotaFinal())}
                        className="my-2"
                    >
                        Calcular
                    </Button>

                    {isResult &&
                        <div className='col-md-12 box border p-4 my-2' style={{ borderRadius: "20px" }}>
                            <div className='d-flex justify-content-center align-items-center'>
                                <h4>Média Final</h4>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-md-12 my-2'>
                                    <h3>Média Final: {finalGrades && finalGrades.totalFinal} valores</h3>
                                    <br></br>
                                    <h5>Média 1A 1S: {finalGrades && finalGrades.total1A1S} valores</h5>
                                    <h5>Média 1A 2S: {finalGrades && finalGrades.total1A2S} valores</h5>
                                    <h5>Média 2A 1S: {finalGrades && finalGrades.total2A1S} valores</h5>
                                    <h5>Média 2A 2S: {finalGrades && finalGrades.total2A2S} valores</h5>
                                    <h5>Média 3A 1S: {finalGrades && finalGrades.total3A1S} valores</h5>
                                    <h5>Média 3A 2S: {finalGrades && finalGrades.total3A2S} valores</h5>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}